<template>
	<div class="home">
		<img alt="Vue logo" src="../assets/logo.png"/>
		<HelloWorld msg="Welcome to Your Vue.js + TypeScript App"/>
	</div>
</template>

<script lang="ts">

    import HelloWorld from "@/components/HelloWorld.vue";
    import { Component, Vue } from "vue-facing-decorator"; // @ is an alias to /src

    @Component({
        components: {
            HelloWorld,
        },
    })
    export default class Home extends Vue {
    }
</script>
